module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Italic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Italic.woff
// module id = 48
// module chunks = 8